module.exports = __webpack_public_path__ + "media/images/card-3e929f23428e81dc61cd24e1b5dab0e8.svg";